export const AUDIENCE_INSIGHTS_REPORT_ID = 'audience-insights';
